module.exports = __webpack_public_path__ + "img/L2_Door.63d43756.svg";